(() => {
  'use strict';
  if (document.querySelector('[data-aara-favorites-ready]')) return;
  const settingsNode = document.getElementById('AaraFavoritesSettings');
  if (!settingsNode) return;
  const settings = JSON.parse(settingsNode.textContent);
  const t = settings.strings;
  const STORAGE_KEY = 'aara_favorites_v1';
  const CARD = '.product-card-wrapper, .aara-bestsellers__item';
  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  let items = readStored();
  let memoryOnly = false;
  let returnFocus;
  let refreshVersion = 0;

  function productUrl(value) {
    try {
      const url = new URL(value, location.origin);
      const match = url.pathname.match(/\/products\/([a-zA-Z0-9_-]+)\/?$/);
      return url.origin === location.origin && match ? settings.root + 'products/' + match[1] : '';
    } catch (_) { return ''; }
  }

  function imageUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' ? url.href : '';
    } catch (_) { return ''; }
  }

  function cleanItems(value) {
    if (!Array.isArray(value)) return [];
    const seen = new Set();
    return value.flatMap(item => {
      if (!item || typeof item !== 'object') return [];
      const url = productUrl(item.url);
      if (!url || seen.has(url)) return [];
      seen.add(url);
      return [{
        url,
        title: typeof item.title === 'string' ? item.title.slice(0, 500) : t.product,
        image: imageUrl(item.image),
        price: typeof item.price === 'string' ? item.price.slice(0, 100) : '',
        currency: typeof item.currency === 'string' ? item.currency : settings.currency
      }];
    });
  }

  function readStored() {
    try { return cleanItems(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')); }
    catch (_) { return []; }
  }

  function persist() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      memoryOnly = false;
    } catch (_) { memoryOnly = true; }
  }

  const status = document.createElement('div');
  status.className = 'aara-favorites-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.dataset.aaraFavoritesReady = 'true';
  document.body.append(status);

  function announce(message) {
    status.textContent = message;
    status.classList.toggle('aara-favorites-status--visible', memoryOnly);
    if (memoryOnly) status.textContent += ' ' + t.session_only;
  }

  const drawer = document.createElement('dialog');
  drawer.id = 'AaraFavoritesDrawer';
  drawer.className = 'aara-favorites-drawer';
  drawer.setAttribute('aria-labelledby', 'AaraFavoritesTitle');
  drawer.innerHTML = '<div class="aara-favorites-panel__header"><h2 id="AaraFavoritesTitle"></h2><button type="button" class="aara-favorites-close" autofocus><span aria-hidden="true">×</span></button></div><p class="aara-favorites-note"></p><div class="aara-favorites-list"></div>';
  drawer.querySelector('h2').textContent = t.title;
  drawer.querySelector('.aara-favorites-note').textContent = t.browser_note;
  const closeButton = drawer.querySelector('.aara-favorites-close');
  closeButton.setAttribute('aria-label', t.close);
  closeButton.addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', event => {
    const box = drawer.getBoundingClientRect();
    if (event.target === drawer && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) drawer.close();
  });
  drawer.addEventListener('close', () => {
    document.body.classList.remove('aara-favorites-open');
    document.querySelectorAll('.aara-favorites-header').forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (returnFocus?.isConnected) returnFocus.focus();
  });
  drawer.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const targets = Array.from(drawer.querySelectorAll('button:not([disabled]), a[href], select:not([disabled])'));
    const first = targets[0];
    const last = targets[targets.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  document.body.append(drawer);

  function openDrawer(event) {
    returnFocus = event.currentTarget;
    renderDrawer();
    if (!drawer.open) drawer.showModal();
    document.body.classList.add('aara-favorites-open');
    returnFocus.setAttribute('aria-expanded', 'true');
    closeButton.focus();
    refreshPrices();
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function updateStates() {
    const urls = new Set(items.map(item => item.url));
    document.querySelectorAll('.aara-favorite-button').forEach(button => {
      const active = urls.has(button.dataset.favoriteUrl);
      button.classList.toggle('is-favorite', active);
      button.setAttribute('aria-pressed', String(active));
      const action = active ? t.remove : t.add;
      button.setAttribute('aria-label', action + ': ' + button.dataset.favoriteTitle);
      button.title = action;
      setText(button.querySelector('.aara-favorite-label'), active ? t.added : t.add);
    });
    document.querySelectorAll('.aara-favorites-header').forEach(button => {
      button.setAttribute('aria-label', t.open + ' (' + items.length + ')');
      button.classList.toggle('is-favorite', items.length > 0);
      const count = button.querySelector('.aara-favorites-count');
      setText(count, String(items.length));
      count.hidden = items.length === 0;
    });
  }

  function toggle(item) {
    if (!memoryOnly) items = readStored();
    const exists = items.some(saved => saved.url === item.url);
    items = exists ? items.filter(saved => saved.url !== item.url) : [item, ...items];
    persist();
    updateStates();
    announce((exists ? t.removed : t.added) + ': ' + item.title);
  }

  function currentPrice(root) {
    const price = root.querySelector('.price');
    const node = price?.classList.contains('price--on-sale')
      ? price.querySelector('.price__sale .price-item--sale')
      : price?.querySelector('.price__regular .price-item--regular');
    return (node?.textContent || root.querySelector('.aara-bestsellers__price > span:last-child')?.textContent || '').trim();
  }

  function cardItem(card) {
    const link = card.querySelector('a[href*="/products/"]');
    const url = productUrl(link?.href);
    if (!url) return null;
    const image = card.querySelector('img');
    return {
      url,
      title: (card.querySelector('.card__heading, h3')?.textContent || image?.alt || t.product).trim(),
      image: imageUrl(image?.currentSrc || image?.src),
      price: currentPrice(card),
      currency: settings.currency
    };
  }

  function productItem(info) {
    const url = productUrl(info.closest('product-info')?.dataset.url || location.href);
    if (!url) return null;
    const area = info.closest('product-info') || info.closest('.product') || document;
    const image = area.querySelector('.product__media img, .product__media-list img');
    return {
      url,
      title: (info.querySelector('.product__title h1, h1')?.textContent || document.querySelector('h1')?.textContent || t.product).trim(),
      image: imageUrl(image?.currentSrc || image?.src),
      price: currentPrice(info),
      currency: settings.currency
    };
  }

  function makeButton(getItem, variant) {
    const item = getItem();
    if (!item) return null;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'aara-favorite-button aara-favorite-' + variant;
    button.dataset.favoriteUrl = item.url;
    button.dataset.favoriteTitle = item.title;
    button.innerHTML = '<span class="aara-favorite-heart">' + heart + '</span>' + (variant === 'product' ? '<span class="aara-favorite-label"></span>' : '');
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const latest = getItem();
      if (latest) toggle(latest);
    });
    return button;
  }

  function install() {
    observer.disconnect();
    try {
      document.querySelectorAll('.header__icons').forEach(icons => {
        if (icons.querySelector('.aara-favorites-header')) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'header__icon header__icon--favorites aara-favorites-header';
        button.title = t.title;
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', drawer.id);
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = '<span class="aara-header-heart">' + heart + '</span><span class="aara-favorites-count" aria-hidden="true"></span>';
        button.addEventListener('click', openDrawer);
        icons.insertBefore(button, icons.querySelector('.header__icon--cart'));
      });
      document.querySelectorAll(CARD).forEach(card => {
        if (card.querySelector('.aara-favorite-card')) return;
        const button = makeButton(() => cardItem(card), 'card');
        if (!button) return;
        card.classList.add('aara-favorite-card-host');
        card.append(button);
      });
      document.querySelectorAll('[id^="ProductInfo-"], .product__info-container').forEach(info => {
        if (info.querySelector('.aara-favorite-product')) return;
        const button = makeButton(() => productItem(info), 'product');
        if (!button) return;
        const form = info.querySelector('product-form, .product-form');
        if (form) form.before(button);
        else info.append(button);
      });
      updateStates();
    } finally {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function renderDrawer() {
    const list = drawer.querySelector('.aara-favorites-list');
    list.replaceChildren();
    if (!items.length) {
      const empty = element('div', 'aara-favorites-empty');
      empty.append(element('p', '', t.empty));
      const link = element('a', 'button button--secondary', t.shop);
      link.href = settings.root + 'collections/all-products';
      empty.append(link);
      list.append(empty);
      return;
    }
    items.forEach(item => {
      const row = element('article', 'aara-favorite-item');
      row.dataset.url = item.url;
      const imageLink = element('a', 'aara-favorite-item__image');
      imageLink.href = item.url;
      imageLink.setAttribute('aria-label', item.title);
      if (item.image) {
        const img = element('img', '');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 90;
        img.height = 90;
        imageLink.append(img);
      }
      const details = element('div', 'aara-favorite-item__details');
      const title = element('a', 'aara-favorite-item__title', item.title);
      title.href = item.url;
      const price = element('div', 'aara-favorite-item__price', item.currency === settings.currency ? item.price : '');
      const actions = element('div', 'aara-favorite-item__actions');
      const view = element('a', 'aara-favorite-item__view', t.view);
      view.href = item.url;
      const remove = element('button', 'aara-favorite-item__remove', t.remove_short);
      remove.type = 'button';
      remove.setAttribute('aria-label', t.remove + ': ' + item.title);
      remove.addEventListener('click', () => {
        if (!memoryOnly) items = readStored();
        items = items.filter(saved => saved.url !== item.url);
        persist();
        renderDrawer();
        refreshPrices();
        updateStates();
        announce(t.removed + ': ' + item.title);
        closeButton.focus();
      });
      actions.append(view, remove);
      const cartControls = element('div', 'aara-favorite-item__cart');
      const variantLabel = element('label', 'aara-favorite-item__variant-label', t.choose_option);
      const variants = element('select', 'aara-favorite-item__variant');
      variants.id = 'FavoriteVariant-' + list.children.length;
      variants.setAttribute('aria-label', t.choose_option + ': ' + item.title);
      variantLabel.htmlFor = variants.id;
      variantLabel.hidden = true;
      variants.hidden = true;
      const add = element('button', 'button aara-favorite-item__add', t.loading);
      add.type = 'button';
      add.disabled = true;
      const feedback = element('p', 'aara-favorite-item__feedback');
      feedback.setAttribute('role', 'status');
      const viewCart = element('a', 'aara-favorite-item__view-cart', t.view_cart);
      viewCart.href = settings.root + 'cart';
      viewCart.hidden = true;
      add.addEventListener('click', () => addFavoriteToCart(row, item));
      variants.addEventListener('change', () => {
        add.disabled = !variants.value;
        add.textContent = t.add_to_cart;
        feedback.textContent = '';
        const option = variants.selectedOptions[0];
        if (option?.dataset.price) setText(price, option.dataset.price);
      });
      cartControls.append(variantLabel, variants, add, feedback, viewCart);
      details.append(title, price, cartControls, actions);
      row.append(imageLink, details);
      list.append(row);
    });
  }


  function formatPrice(amount) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: settings.currency }).format(amount / 100);
  }

  function setCartOptions(row, product) {
    const add = row.querySelector('.aara-favorite-item__add');
    const select = row.querySelector('.aara-favorite-item__variant');
    const label = row.querySelector('.aara-favorite-item__variant-label');
    const variants = Array.isArray(product.variants) ? product.variants : [];
    if (product.requires_selling_plan) {
      add.textContent = t.choose_on_product;
      row.dataset.requiresPlan = 'true';
      add.disabled = false;
      return;
    }
    if (!variants.some(variant => variant.available)) {
      add.textContent = t.sold_out;
      add.disabled = true;
      return;
    }
    if (variants.length === 1) {
      row.dataset.variantId = String(variants[0].id);
      add.textContent = t.add_to_cart;
      add.disabled = false;
      return;
    }
    select.replaceChildren();
    const placeholder = element('option', '', t.choose_option);
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.append(placeholder);
    variants.forEach(variant => {
      const option = element('option', '', variant.title + (variant.available ? '' : ' — ' + t.sold_out));
      option.value = String(variant.id);
      option.disabled = !variant.available;
      option.dataset.price = formatPrice(variant.price);
      select.append(option);
    });
    select.hidden = false;
    label.hidden = false;
    add.textContent = t.add_to_cart;
    add.disabled = true;
  }

  async function addFavoriteToCart(row, item) {
    if (row.dataset.requiresPlan) {
      location.assign(item.url);
      return;
    }
    const add = row.querySelector('.aara-favorite-item__add');
    const select = row.querySelector('.aara-favorite-item__variant');
    const feedback = row.querySelector('.aara-favorite-item__feedback');
    const viewCart = row.querySelector('.aara-favorite-item__view-cart');
    const variantId = select.hidden ? row.dataset.variantId : select.value;
    if (add.disabled || !variantId || row.dataset.adding === 'true') return;
    row.dataset.adding = 'true';
    add.disabled = true;
    select.disabled = true;
    add.textContent = t.adding;
    feedback.textContent = '';
    let result;
    let confirmed = false;
    try {
      const response = await fetch(settings.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: ['cart-icon-bubble', 'cart-drawer'],
          sections_url: location.pathname
        })
      });
      result = await response.json();
      confirmed = true;
      if (!response.ok || result.status) {
        feedback.textContent = typeof result.description === 'string' ? result.description : t.cart_error;
        add.textContent = t.add_to_cart;
        return;
      }
      feedback.textContent = t.added_to_cart;
      add.textContent = t.add_another;
      viewCart.hidden = false;
    } catch (_) {
      feedback.textContent = t.cart_uncertain;
      viewCart.hidden = false;
      add.textContent = t.add_to_cart;
      return;
    } finally {
      row.dataset.adding = 'false';
      add.disabled = false;
      select.disabled = false;
    }
    if (!confirmed) return;
    const bubbleHtml = result.sections?.['cart-icon-bubble'];
    if (bubbleHtml) {
      const bubble = document.getElementById('cart-icon-bubble');
      const content = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (bubble && content) bubble.innerHTML = content.innerHTML;
    }
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer?.renderContents && result.sections?.['cart-drawer']) {
      drawer.close();
      cartDrawer.setActiveElement(document.querySelector('.aara-favorites-header'));
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(result);
    } else if (/\/cart\/?$/.test(location.pathname)) {
      location.reload();
    }
  }

  async function refreshPrices() {
    const version = ++refreshVersion;
    await Promise.all(items.map(async saved => {
      try {
        const response = await fetch(saved.url + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product unavailable');
        const product = await response.json();
        if (version !== refreshVersion || !Number.isFinite(product.price)) return;
        const item = items.find(item => item.url === saved.url);
        if (!item) return;
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: settings.currency }).format(product.price / 100);
        item.price = product.price_varies ? t.from.replace('[price]', amount) : amount;
        item.currency = settings.currency;
        drawer.querySelectorAll('.aara-favorite-item').forEach(row => {
          if (row.dataset.url === item.url) {
            setText(row.querySelector('.aara-favorite-item__price'), item.price);
            setCartOptions(row, product);
          }
        });
      } catch (_) {
        if (version !== refreshVersion) return;
        drawer.querySelectorAll('.aara-favorite-item').forEach(row => {
          if (row.dataset.url !== saved.url) return;
          row.querySelector('.aara-favorite-item__add').textContent = t.unavailable;
          row.querySelector('.aara-favorite-item__feedback').textContent = t.product_load_error;
        });
      }
    }));
  }

  let queued = false;
  const observer = new MutationObserver(records => {
    if (queued || !records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.(CARD + ', product-info, .header__icons, [id^="ProductInfo-"]') || node.querySelector?.(CARD + ', product-info, .header__icons, [id^="ProductInfo-"]'))))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; install(); });
  });
  window.addEventListener('storage', event => {
    if (event.key !== STORAGE_KEY && event.key !== null) return;
    memoryOnly = false;
    items = readStored();
    updateStates();
    if (drawer.open) { renderDrawer(); refreshPrices(); }
  });
  window.addEventListener('pageshow', () => {
    if (!memoryOnly) items = readStored();
    install();
  });
  document.addEventListener('shopify:section:load', install);
  install();
})();